"use strict";

require("core-js/modules/es6.string.fixed");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asset_accessor_1 = require("../asset-accessor");

var util_1 = require("../util");

var GraphQLFileAccessor =
/** @class */
function () {
  function GraphQLFileAccessor(base) {
    this.base = base;
  }
  /**
   *
   * @param defaultValue
   * @deprecated
   */


  GraphQLFileAccessor.prototype.url = function (defaultValue) {
    throw new Error('GraphQLFileAccessorError: dont use url() anymore');
  };

  GraphQLFileAccessor.prototype.fluid = function (opts) {
    if (this.base && this.base.childImageSharp && this.base.childImageSharp.fluid) {
      return this.base.childImageSharp.fluid;
    }

    return util_1.createFallbackFluidImageObject(opts && opts.fallbackImage);
  };

  GraphQLFileAccessor.prototype.fixed = function (opts) {
    if (this.base && this.base.childImageSharp && this.base.childImageSharp.fixed) {
      return this.base.childImageSharp.fixed;
    }

    return util_1.createFallbackFixedImageObject(opts && opts.fallbackImage);
  };

  GraphQLFileAccessor.prototype.title = function () {
    return undefined;
  };

  GraphQLFileAccessor.prototype.type = function () {
    return asset_accessor_1.AssetType.Unknown;
  };

  return GraphQLFileAccessor;
}();

exports.GraphQLFileAccessor = GraphQLFileAccessor;